const comArray = [
  {
    name: "vision",
    childrens: [{ name: "Eye Exams" }, { name: "Eyewear" }],
  },
  {
    name: "hospital",
    childrens: [
      { name: "Inpatient Hospital" },
      { name: "Outpatient Hospital & Observation" },
      { name: "Emergency Care" },
      { name: "Ground & Air Ambulance" },
      { name: "Skilled Nursing (SNF)" },
    ],
  },
  {
    name: "dental",
    childrens: [{ name: "Preventative (Routine)" }, { name: "Comprehensive" }],
  },
  {
    name: "overview",
    childrens: [
      { name: "Monthly Premium" },
      { name: "Deductible" },
      { name: "Maximum Out-of-Pocket" },
      { name: "Part B Rebate" },
    ],
  },
  {
    name: "prescriptions",
    childrens: [
      { name: "Part D Deductible" },
      { name: "Initial Coverage Limit" },
      { name: "Part D Out-of-Pocket Threshold" },
    ],
  },
  {
    name: "prescriptions-tiers",
    childrens: [
      { name: "Tier 1: Preferred Generic" },
      { name: "Tier 2: Generic" },
      { name: "Tier 3: Preferred Brand" },
      { name: "Tier 4: Non-Preferred" },
      { name: "Tier 5: Specialty Tier" },
      { name: "Tier 6: Select Care" },
    ],
  },
  {
    name: "additional-benefits",
    childrens: [
      { name: "24/7 Concierge Service" },
      { name: "Over-the-Counter (OTC) Allowance" },
      { name: "FLEX Allowance" },
      { name: "Transportation" },
      { name: "Caregiver Support" },
      { name: "Grocery SSBCI Eligible" },
    ],
  },
  {
    name: "doctors",
    childrens: [{ name: "PCP Copay" }, { name: "Specialist Copay" }],
  },
];

export default comArray;
